var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-login-callback"},[_c('AtomLoadingPrimary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }